import { render } from "./AnalysisExpanded.vue?vue&type=template&id=48ff5fb5&scoped=true&ts=true"
import script from "./AnalysisExpanded.vue?vue&type=script&lang=ts"
export * from "./AnalysisExpanded.vue?vue&type=script&lang=ts"

import "./AnalysisExpanded.vue?vue&type=style&index=0&id=48ff5fb5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ff5fb5"]])

export default __exports__